import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import moment from 'moment';

import { environment } from '../../../environments/environment';
import { DateHandler, MY_FORMATS } from '../../scripts/date-handler';
import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'wedate-input',
  templateUrl: './wedate-input.component.html',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
  standalone: false,
})
export class WedateInputComponent implements OnInit {
  @Input() hasIncrementors: boolean;
  @Input() dateHandler: DateHandler;
  @Input() shouldDisable: boolean;

  @Output() public readonly weDateChanged = new EventEmitter();

  weDateControl!: FormControl<moment.Moment>;
  restrictDate: moment.Moment = moment(new Date(environment.restrictDate || null));

  isDecrementorAllowed = true;

  constructor(public datahub: DatahubService) {}

  onlySaturdays = (d: moment.Moment | null): boolean => {
    // if environment.ts has goLiveDate set a moment object to that date string, if goLiveDate has nothing (empty string) then use todays date
    const date = moment(d);
    const day = (d || moment()).days();

    // Saturday is only day of week able to be selected, then we also check if the date selected on calendar (date) is beyond the date we are setting (goLiveDate) which is accessed in environment
    return day === 6 && date.isAfter(this.restrictDate, 'day');
  };

  // day.days() returns number (day of week) I'm going to try and get the full and then compare, the goal is this is called and when returns true that's what shows on calendar

  ngOnInit(): void {
    if (!this.dateHandler) throw new Error('you must supply a datehandler class instance to this component.');
    this.weDateControl = this.dateHandler.getControl();
    if (this.shouldDisable) this.weDateControl.disable();
    this.weDateControl.valueChanges.subscribe({
      next: () => (this.isDecrementorAllowed = this.shouldAllowDecrementor(this.restrictDate, this.weDateControl.value)),
      error: (err) => {
        console.error('Error in weDateControl valueChanges subscription:', err);
      },
    });
    this.isDecrementorAllowed = this.shouldAllowDecrementor(this.restrictDate, this.weDateControl.value);
  }

  increment() {
    this.dateHandler.incrementWeDate();
    this.emit();
  }

  decrement() {
    this.dateHandler.decrementWeDate();
    this.emit();
  }

  emit() {
    this.weDateChanged.emit(this.dateHandler.selectedDate.value);
  }

  shouldAllowDecrementor(floorDate: moment.Moment, currentDate: moment.Moment) {
    return currentDate.isAfter(floorDate.clone().add(1, 'week'), 'day');
  }
}
